var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.stageIsComplete)?_c('v-btn',{staticClass:"mx-2",on:{"click":_vm.handleClickIncomplete}},[_vm._v("Set Stage Incomplete")]):_vm._e(),(!_vm.stageIsComplete)?_c('v-btn',{staticClass:"mx-2",attrs:{"color":"secondary"},on:{"click":_vm.handleClick}},[_vm._v("Set Stage Complete")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }